// templateStyles.js

export const gold = '#C58A2A';

export const templatePageSx = {
  width: '100%',

  height: 'calc(100vh - 58px)',
  minHeight: 0,

  display: 'flex',
  flexDirection: 'column',

  bgcolor: '#F7F7F7',

  overflow: 'hidden'
};

export const tabsWrapperSx = {
  px: 1.5,
  bgcolor: '#FFFFFF'
};

export const tabsSx = {
  minHeight: 34,
  borderBottom: '1px solid #E5E5E5',

  '& .MuiTabs-flexContainer': {
    alignItems: 'center'
  },

  '& .MuiTabs-indicator': {
    height: 2,
    bgcolor: gold
  }
};

export const tabSx = {
  minHeight: 34,
  minWidth: 'auto',

  px: 1.25,
  py: 0.625,

  mr: 0.5,

  color: '#555555',

  fontSize: 11,
  fontWeight: 400,

  textTransform: 'none',

  borderRadius: 0,

  '&:hover': {
    color: gold,
    bgcolor: '#FFFDF9'
  },

  '&.Mui-selected': {
    color: gold,
    fontWeight: 500,
    bgcolor: 'transparent'
  },

  '& .MuiTab-iconWrapper': {
    mr: 0.625,
    mb: '0 !important'
  },

  '& svg': {
    width: 14,
    height: 14
  }
};

export const tabContentSx = {
  width: '100%',
  px: 2,
  pt: 1.5,
  pb: 2
};

